"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _constants = require("./lib/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var BotsApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(BotsApi, _BasicDataHubApi);

  function BotsApi() {
    (0, _classCallCheck2.default)(this, BotsApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BotsApi).apply(this, arguments));
  }

  (0, _createClass2.default)(BotsApi, [{
    key: "deleteBot",
    value: function () {
      var _deleteBot = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(bot) {
        var temporarily,
            binding,
            method,
            accountId,
            _ref,
            requestId,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                temporarily = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
                _context.next = 3;
                return this.getBinding();

              case 3:
                binding = _context.sent;
                method = this._getMethodName(temporarily ? 'deleteTemporarily' : 'delete');
                accountId = this.accountId;
                _context.next = 8;
                return binding.mutation[method](_objectSpread({
                  entity: _constants.BOT,
                  data: {
                    id: bot.id,
                    subscribe: true
                  }
                }, accountId ? {
                  accountId: accountId
                } : {}));

              case 8:
                _ref = _context.sent;
                requestId = _ref.requestId;
                return _context.abrupt("return", this.subscribe(requestId));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function deleteBot(_x) {
        return _deleteBot.apply(this, arguments);
      }

      return deleteBot;
    }()
  }, {
    key: "recoverBot",
    value: function () {
      var _recoverBot = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(bot) {
        var binding, method, accountId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getBinding();

              case 2:
                binding = _context2.sent;
                method = this._getMethodName('recover');
                accountId = this.accountId;
                return _context2.abrupt("return", binding.mutation[method](_objectSpread({
                  entity: _constants.BOT,
                  data: {
                    id: bot.id
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function recoverBot(_x2) {
        return _recoverBot.apply(this, arguments);
      }

      return recoverBot;
    }()
  }, {
    key: "getBotById",
    value: function () {
      var _getBotById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(botId, projection) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._callApi({
                  path: "/v2/".concat(this.accountIdFactory, "/bot/").concat(botId),
                  queryParams: {
                    projection: projection,
                    includeDeleted: false,
                    includeExisting: true
                  }
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getBotById(_x3, _x4) {
        return _getBotById.apply(this, arguments);
      }

      return getBotById;
    }()
  }, {
    key: "getBots",
    value: function () {
      var _getBots = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(_ref2) {
        var _ref2$query, query, projection, _ref2$includeDeleted, includeDeleted, _ref2$includeExisting, includeExisting, method, accountId;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref2$query = _ref2.query, query = _ref2$query === void 0 ? {} : _ref2$query, projection = _ref2.projection, _ref2$includeDeleted = _ref2.includeDeleted, includeDeleted = _ref2$includeDeleted === void 0 ? false : _ref2$includeDeleted, _ref2$includeExisting = _ref2.includeExisting, includeExisting = _ref2$includeExisting === void 0 ? true : _ref2$includeExisting;
                method = this._getMethodName('list');
                accountId = this.accountId;
                return _context4.abrupt("return", this._getPaginatedList(method, _objectSpread({
                  entity: _constants.BOT,
                  params: {
                    ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
                    queryParams: query,
                    includeDeleted: includeDeleted,
                    includeExisting: includeExisting
                  }
                }, accountId ? {
                  accountId: accountId
                } : {
                  sandbox: false
                }), projection));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getBots(_x5) {
        return _getBots.apply(this, arguments);
      }

      return getBots;
    }()
  }, {
    key: "getBotsByToken",
    value: function () {
      var _getBotsByToken = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref3) {
        var _ref3$query, query, projection, limit, token, binding, method, accountId;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref3$query = _ref3.query, query = _ref3$query === void 0 ? {} : _ref3$query, projection = _ref3.projection, limit = _ref3.limit, token = _ref3.token;
                _context5.next = 3;
                return this.getBinding();

              case 3:
                binding = _context5.sent;
                method = this._getMethodName('list');
                accountId = this.accountId;
                return _context5.abrupt("return", binding.query[method](_objectSpread({
                  entity: _constants.BOT,
                  params: {
                    ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
                    queryParams: query,
                    limit: limit,
                    last: token
                  }
                }, accountId ? {
                  accountId: accountId
                } : {
                  sandbox: false
                }), projection || ['records', 'last']));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getBotsByToken(_x6) {
        return _getBotsByToken.apply(this, arguments);
      }

      return getBotsByToken;
    }()
  }, {
    key: "saveBot",
    value: function () {
      var _saveBot = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(bot) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this._callApi({
                  path: "/v2/".concat(this.accountIdFactory, "/bot/").concat(bot.id || 'new'),
                  payload: {
                    bot: bot
                  },
                  method: 'post'
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveBot(_x7) {
        return _saveBot.apply(this, arguments);
      }

      return saveBot;
    }()
  }], [{
    key: "getNewBot",
    value: function () {
      var _getNewBot = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7() {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", {
                  data: {
                    label: '',
                    description: '',
                    longDescription: '',
                    iconUrl: '',
                    deploy: {}
                  }
                });

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getNewBot() {
        return _getNewBot.apply(this, arguments);
      }

      return getNewBot;
    }()
  }]);
  return BotsApi;
}(_basic_data_hub_api.default);

var _default = BotsApi;
exports.default = _default;